import main from './lib/BamTeamData';

export default main;

